require('public/css/catalog.scss');

const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');
var isLoadingFacetsCatalog = false;

const { trackCategoryListEvent } = require('public/js/lib/adobe-dtm-helper');
let searchFacetParams = [];
const { PAGES } = require('public/js/constants/pages');

const catalog = {
	getCategoryId: function () {
		return parseInt(rp$('.catalog-products').data('category'));
	},
};

catalog.getAvailableSearchFacetQueryNames = function() {
	const facets = Array.from(
		document.querySelectorAll('.search-facets-module .facet-wrapper')
	);

	return facets.map((facet) => facet.getAttribute('data-query-name'));
};

catalog.getSearchResultsCatalog = function (changedField, params) {
	// Check if we're on a /products page - use AJAX like /search
	if (catalog.groupAndSubgroup === PAGES.PRODUCTS) {
		// Add pUrl parameter like in search-helper.js
		const pUrl = rp_app.location.pathname.replace(/^\//, '');
		params.pUrl = pUrl;
		
		// For /products pages, use AJAX flow (new behavior)
		let historyUrl = null;
		if (changedField !== 'history') {
			historyUrl = catalog.buildHistoryUrl(params);
		}

		if (changedField === 'page') {
			params.load_facets = 0;
		} else {
			params.load_facets = 1;
		}

		if (window.__DISABLE_SEARCH_HISTORY_HANDLER) {
			rp_app.location.redirect(historyUrl);
			return;
		}

		Object.keys(params).forEach(key => {
			if (Array.isArray(params[key])) {
				params[key] = params[key].join(',');
			}
		});

		rp$(document).trigger('searchResults:request');

		const fetchUrl = catalog.buildFetchUrl();

		$ajax({
			method: 'GET',
			dataType: 'json',
			data: params,
			url: fetchUrl,
			error: (/*j, textStatus, error*/) => {
				rp$(document).trigger('searchResults:error');
			},
			success: (response/*, status, xhr*/) => {
				if (historyUrl !== null) {
					try {
						window.history.pushState({}, '', historyUrl);
					}
					catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */ }
				}

				rp$(document).trigger('searchResults:response', response);
			},
			complete: () => {
				isLoadingFacetsCatalog = false;
			}
		});
		return;
	}
	
	// For other pages (not /products), use original page reload logic
	let historyUrl = null;
	if (changedField !== 'history') {
		historyUrl = catalog.buildHistoryUrl(params);
	}
	if (historyUrl) {
		window.location.href = historyUrl;
	}
};

const groupAndSubgroup = window.location.pathname.split('/')[2];
if (groupAndSubgroup) {
	catalog.groupAndSubgroup = groupAndSubgroup;
}

catalog.buildFetchUrl = function () {
	// For /products pages, always use /ajax/search
	if (this.groupAndSubgroup === PAGES.PRODUCTS) {
		return '/ajax/search';
	}
	
	catalog.type = catalog.getCategoryId() ? 'catalog-c' : 'refresh-assemblies';
	
	let url;
	switch (catalog.type) {
		case 'refresh-assemblies':
			url = `/ajax/oem-assemblies-search/${this.groupAndSubgroup}`;
			break;
		case 'catalog-c':
			url = `/ajax/catalog/c-${catalog.getCategoryId()}`;
			break;
		default:
			url = `/ajax/catalog/c-${catalog.getCategoryId()}`;
	}
	
	return url;
};

catalog.buildHistoryUrl = function (requestParams) {
	Object.keys(requestParams).forEach(key => {
		if (Array.isArray(requestParams[key])) {
			requestParams[key] = requestParams[key].join(',');
		}
	});

	let baseUrl = rp$('base').attr('href');
	if (!baseUrl || typeof baseUrl === 'string') {
		baseUrl = rp_app.location.getBase();
	}
	const currentPath = rp_app.location.pathname.replace(/^\//, '');
	const targetParams = rp$.extend(rp_app.query.all(), requestParams);
	delete targetParams['identifier'];
	delete targetParams['use_cfc'];

	return baseUrl + '/' + currentPath + '?' + rp$.param(targetParams);
};

catalog.handleHistoryChange = function (/*evt*/) {
	const args = rp_app.query.all(rp_app.location.href);
	const params = {
		page: args.page,
	};

	catalog.getSearchResultsCatalog('history', params);
};

catalog.handlePageChange = function (pageNum) {
	const args = rp_app.query.all(rp_app.location.href);
	const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();

	const params = {
		page: pageNum,
		...partTypeFilters
	};
	searchFacetParams.forEach((facet) => {
		if (args[facet]) {
			params[facet] = decodeURIComponent(args[facet]);
		}
	});
	catalog.getSearchResultsCatalog('page', params);
};

if (!window.__DISABLE_SEARCH_HISTORY_HANDLER) {
	window.addEventListener('popstate', catalog.handleHistoryChange);

	rp$(document).off('searchResults:pageChange');
	rp$(document).on('searchResults:pageChange', function handlePageChange(evt, pageNum) {
		evt.preventDefault();
		catalog.handlePageChange(pageNum);
	});
}

catalog.prepareCatalog = function () {
	searchFacetParams = catalog.getAvailableSearchFacetQueryNames();
	const productRows = rp$('.catalog-product.marketplace-product');
	// Track Adobe DTM category page view
	if (productRows.length) {
		trackCategoryListEvent();
	}

	const $partTypeFilter = rp$('.part-type-filter-form');
	if ($partTypeFilter.length > 0) {
		const $searchListingModule = rp$('.search-listing-module');
		if ($searchListingModule.length === 0) {
			$partTypeFilter.on('changeAdditionalFilters', function handleAdditionalFilterChange(evt, filters) {
				catalog.type = 'catalog-c';
				catalog.getSearchResultsCatalog('', filters);
			});
		}
	}

	const $facetsModule = rp$('.search-facets-module');
	if ($facetsModule.length > 0) {
		// Only register this listener if we're NOT on a page handled by search-helper.js
		// Pages with .search-listing-module are handled by search-helper.js (includes /search, /products, etc.)
		// This prevents duplicate AJAX calls from both helpers
		const $searchListingModule = rp$('.search-listing-module');
		if ($searchListingModule.length === 0) {
			$facetsModule.on('selectedFacetBucketsChanged', function handleSelectedBucketsChange(e, queryParams) {
				catalog.type = catalog.getCategoryId() ? 'catalog-c' : 'refresh-assemblies';
				// Factor existing vehicle filter params into search
				const partTypeFilters = partTypeFilterHelpers.getAdditionalFilterValuesFromDom();
				const updatedParams = { ...queryParams, ...partTypeFilters };
				if(!isLoadingFacetsCatalog) {
					isLoadingFacetsCatalog = true;
					catalog.getSearchResultsCatalog('', updatedParams);
				}
			});
		}
	}
};

module.exports = catalog;